import { render } from "./Towingservices.vue?vue&type=template&id=3b915ee6&scoped=true"
import script from "./Towingservices.vue?vue&type=script&lang=js"
export * from "./Towingservices.vue?vue&type=script&lang=js"

import "./Towingservices.vue?vue&type=style&index=0&id=3b915ee6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b915ee6"]])

export default __exports__